(function() {
  
  
  window.SideCart = window.SideCart || new function() {
    //runs once per page load
    var self = this;
    var isOpen = false;
    
    document.addEventListener('mousedown', function(event){
      var sideCart = document.getElementById('side-cart');
      if(!sideCart || (!event.target.closest('#side-cart') && event.target.id!="loading-overlay" && sideCart.classList.contains('open'))) {
        self.hideSideCart();
      }
    });

    self.isOpen = function() {
      return isOpen;
    }
    self.updateSideCart = function(open) {
      if (open) {
        $s.showLoadingOverlay();
      }
      $s.getJson({url: '/?sections=side_cart', success: function(data){
        var section = document.getElementById('shopify-section-side_cart');
        if (section)
          section.parentNode.removeChild(section);
        document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
        if (open) {
          $s.hideLoadingOverlay();
        }
        self.openAfterUpdate = open;
        $s.globalEval(data["side_cart"]);
      }});
    }

    self.showSideCart = function(animate) {
      $s.closeModal();

      isOpen = true;
      var sideCart = document.getElementById('side-cart');
      $s.showOverlay()
      if(animate) {
        setTimeout(function(){sideCart.classList.add('open')}, 100);
      } else {
        sideCart.classList.remove('ease-animation-slow');
        sideCart.classList.add('open');
        setTimeout(function(){sideCart.classList.add('ease-animation-slow')}, 200);
      }
      $s.updateCartBadge();
      $s.trapFocus(sideCart);

    };

    self.hideSideCart = function() {
      isOpen = false;
      var sideCart = document.getElementById('side-cart');
      $s.hideOverlay();
      sideCart.classList.remove('open');
      $s.removeTrapFocus();
    };

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);$s.addToCartSuccess();
        },
        error: $s.addToCartFail
      });
    }

    self.postChange = function(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          window.SideCart.updateSideCart(window.SideCart.isOpen());
        },
        error: $s.addToCartFail
      });
    }

    self.postAdd = function(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
          window.SideCart.updateSideCart(window.SideCart.isOpen());
        },
        error: $s.addToCartFail
      });
    }



    window.addEventListener('keydown', function(e){
      if (e.which == 27) { //Exit
        var sideCart = document.getElementById('side-cart');
        if(sideCart.classList.contains('open')){
          e.preventDefault();
          window.SideCart.hideSideCart();
          return false;
        }
      }
    });
  
  };


  //runs every time #side-cart div is replaced
  var sideCart = document.getElementById('side-cart');
  var itemsCount = 0;
  sideCart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });

  var cartCountElement = document.querySelector('header .cart-count');
  if(cartCountElement) {
    cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
  }

  /* REMOVE LAST BORDER ON ITEMS EXCLUDING PROMO DIVS */
  var itemLength = 0;
  sideCart.querySelectorAll('.item').forEach((item) => {
    let cssObj = window.getComputedStyle(item, null);
    let display = cssObj.getPropertyValue("display");
    if (display !== 'none') {
      itemLength++
    }
  })
  document.getElementById('cartItemsBorder').innerHTML = `.cart-items .item:nth-child(n+${itemLength}){border-bottom: none!important}`

  sideCart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate(this.closest('.item'), 0);
      SideCart.updateItemsQuantity(items, 0);
    });
  });

  sideCart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      SideCart.updateItemsQuantity(items, this.value);
    });
  });

  sideCart.querySelector('#side-cart .close').addEventListener('click', function (e) {
    window.SideCart.hideSideCart();
  });

  sideCart.querySelectorAll('.toogle-next').forEach((button) => {
    button.addEventListener('click', () => {
      $s.toggle([button.nextElementSibling]);
    });
  });var returnPolicyButton = sideCart.querySelector('.return-policy-button');
  if (returnPolicyButton) {
    returnPolicyButton.addEventListener('click', function() {
      var panel = this.closest('.return-policy').querySelector('.expandable');
      if (this.getAttribute('aria-expanded')=='false') {
        this.setAttribute('aria-expanded', 'true');
        $s.expand([panel]);
      } else {
        this.setAttribute('aria-expanded', 'false');
        $s.collapse([panel]);
      }
    });
  }document.getElementById('ll-cart-points').setAttribute('data-lion-points-for', window.cart_json.total_price)
  // now that we've updated the element, we tell the sdk to refresh
  window.loyaltylion && window.loyaltylion.ui.refresh
  lion.ui.fetchAndUpdateCart()
  $s.validateBundlesInHTML(document.querySelectorAll('#side-cart .item'));

})();